<template>
  <div>

    <EmptyModal :onModalClose="closeModal" :modalData="modalData" v-if="modalData">
      <slot>
        <img class="w-100" :src="modalData.source" alt="">
      </slot>
    </EmptyModal>

    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-5"/>
    <template v-if="hidePreviewImages || (!loading && loadedFiles.length)">
      <div class="flex flex-wrap">
        <template v-if="hidePreviewImages">
          <div class="img_div" v-for="(img, i) in files" :key="img.id">
            <button class="btn btn-default btn-xs" @click="loadPreview" type="button">загрузить фото</button>
            <div class="text-right small_text" v-if="img.details.uploaded_by">
              <p>{{ img.details.uploaded_by.user_name }} (<span class="text-muted">{{
                  printDate(img.created_at)
                }}</span>)
              </p>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="(img, i) in loadedFiles" :key="i" class="img_div">
            <template v-if="img.link">
              <img @click="openImage(img)" class="imagePreviewWrapper pointer" :src="img.link" alt="">
            </template>
            <div class="text-right small_text" v-if="img.details.uploaded_by">
              <p>{{ img.details.uploaded_by.user_name }} (<span class="text-muted">{{
                  printDate(img.created_at)
                }}</span>)
              </p>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import EmptyModal from "@/components/modals/EmptyModal";

export default {
  props: ['files', 'hidePreview'],
  components: {
    EmptyModal,
  },
  data() {
    return {
      loading: false,
      modalData: null,
      loadedFiles: [],
      hidePreviewImages: false,
    }
  },
  created() {
    this.hidePreviewImages = !!this.hidePreview;
    if (!this.hidePreview) {
      this.getFiles();
    }
  },
  methods: {
    loadPreview() {
      this.hidePreviewImages = false;
      this.getFiles(true);
    },
    async getFiles(silent = false) {
      this.loading = !silent;
      const {data} = await api.index('/new/files/preview?files=' + this.files.map((f) => f.id).join(','));
      if (data.success) {
        this.loadedFiles = data.filesData;
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    },
    closeModal() {
      this.modalData = null;
    },
    openImage(img) {
      this.modalData = {source: img.link, disableFooter: true}
    },
  }
}

</script>

<style scoped>
.img_div {
  /*width: 240px;*/
  width: calc(33% - 5px);
  padding: 5px;
  min-height: 75px;
  position: relative;
  border: 1px solid lightgrey;
  margin-right: 5px;
}

.img_div img {
  width: 100%;
}

.small_text {
  font-size: 10px;
}
</style>
